import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { UnauthorizedError } from '@ember-data/adapter/error';
import { pluralize } from 'ember-inflector';
import { underscore } from '@ember/string';
import { inject } from '@ember/service';
import { notifyUserError } from 'beebee-base/lib/utility';
import getConfig from 'beebee-base/lib/get-config';

var _class, _descriptor, _descriptor2, _descriptor3;
let ApplicationAdapter = (_class = class ApplicationAdapter extends JSONAPIAdapter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "notify", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
    this.namespace = 'v1';
  }
  get host() {
    let domain = location.hostname.split('.').shift();
    const defaultHost = window.location.host;
    domain = domain ? `${domain}.beebeeboard.com` : defaultHost;
    return getConfig(this).environment === 'production' ? `https://${domain}/api` : getConfig(this).APP.host;
  }
  pathForType(type) {
    return pluralize(underscore(type));
  }
  get headers() {
    return this.session.token ? {
      Authorization: `Bearer ${this.session.token}`
    } : {};
  }
  handleResponse(status, headers, body, requestData) {
    if (status >= 200 && status < 300) {
      if (!body) {
        return null;
      }
      return super.handleResponse(status, headers, body, requestData);
    } else if (status === 401) {
      return this._handleUnauthorized();
    } else {
      if (body) {
        notifyUserError(this.notify, body, this.intl);
      }
      return super.handleResponse(status, headers, body, requestData);
    }
  }
  _handleUnauthorized() {
    if (!this.session.allowAnonymous) {
      this.session.logout();
      window.location.reload();
    }
    return new UnauthorizedError();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "notify", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ApplicationAdapter as default };
//# sourceMappingURL=application.js.map
